"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWithIcon = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../../utils");
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TitleWithIcon = ({
  linkTitle,
  linkType
}) => {
  const icon = (0, _utils.getIconByLinkType)(linkType);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TitleIconRoot, {
    "data-testid": getTestId(_constants.TITLE_WITH_ICON),
    children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: linkTitle
    })]
  });
};
exports.TitleWithIcon = TitleWithIcon;
